import { FC, PropsWithChildren } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Box, CircularProgress, Typography } from '@mui/material';

interface IProps extends PropsWithChildren {
	fetchData: () => void;
	hasMore: boolean;
	totalData: number;
	endMessage?: string;
	height?: string;
	isSpinner?: boolean;
}

const AMBGInfiniteScroll: FC<IProps> = (props) => {
	const { fetchData, hasMore, children, endMessage, totalData, height, isSpinner } = props;

	return (
		<InfiniteScroll
			dataLength={totalData}
			hasMore={hasMore}
			next={fetchData}
			loader={
				isSpinner && (
					<Box sx={{ width: '100%', textAlign: 'center' }}>
						<CircularProgress />
					</Box>
				)
			}
			endMessage={
				!isSpinner &&
				totalData > 0 && (
					<Typography style={{ textAlign: 'center' }}>
						<b>{endMessage}</b>
					</Typography>
				)
			}
			height={height || '100%'}
			scrollThreshold={1}
		>
			{children}
		</InfiniteScroll>
	);
};

export default AMBGInfiniteScroll;
